<template>
    <el-dialog :visible.sync="coverShow" width="800px" :show-close="false" center @close="close()">
        <div id="create_cover">
            <div class="create_cover1">
                <div class="cursor_1" :class="coverI == i ? 'create_cover2 create_cover2_1' : 'create_cover2'"
                    v-for="(item, i) in coverList" :key="i" @click="cCover(i)">
                    {{ item }}
                    <div v-if="coverI == i" class="create_cover2_2"></div>
                </div>
                <img @click="close()" class="cursor_1" src="@/assets/image/icon_close.png" alt="">
            </div>
            <!-- Ai生成 -->
            <div v-if="coverI == 0" class="create_cover10">
                <div class="create_cover11">
                    <div class="create_cover12">
                        <div class="create_cover13">
                            <span>封面描述</span>
                        </div>
                        <div class="create_cover14 cursor_1" @click="getRequirement"></div>
                        <div class="loading_text_1" v-if="streamStatus">
                            <img src="@/assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="create_cover15">
                        <el-input type="textarea" ref="nove_fm" :autosize="{ minRows: 3, maxRows: 6 }"
                            placeholder="请输入封面的描述" v-model="describeText" :maxlength="200"></el-input>
                        <!-- 停止生成按钮 -->
                        <AIStopCreate plain :hide="streamStatus" emit @stop="clearTimes" bottom="10px"></AIStopCreate>
                    </div>
                    <div class="create_cover16">
                        <div class="create_cover13">模型</div>
                        <div class="create_cover17">
                            <div class="create_cover18">
                                <div class="create_cover19 cursor_1" v-for="(item, i) in coverQuality" :key="i"
                                    @click="selectQuality(i)" v-if="userInfo.vipType">
                                    <img :src="qualityIndex == i ? iconSelect[2] : iconSelect[0]" alt="">
                                    {{ getQualityText(i) }}
                                </div>
                            </div>
                            <div class="create_cover20">提示:快速生成封面，适合各类小说风格</div>
                        </div>
                        <div class="create_cover21 cursor_1" @click="createCover">AI生成</div>
                    </div>
                    <div class="create_cover22">
                        <div class="create_cover23">
                            <div class="create_cover13">封面内容</div>
                            <div class="create_cover24" @click="delShow = !delShow">
                                <div class="create_cover24_1 cursor_1" v-if="!delShow">
                                    <img :src="iconSelect[8]" alt="">
                                    管理
                                </div>
                                <div v-else>完成</div>
                            </div>

                        </div>
                        <div class="create_cover25">
                            <div class="create_cover26">
                                <div v-if="imgList.length == 0" class="create_cover26_2">
                                    暂无
                                </div>
                                <div class="create_cover26_1" v-else>
                                    <div class="create_cover27" v-for="(item, i) in imgList" :key="i"
                                        @click="selectAiImg(i)">
                                        <div class="create_loading" v-if="item.status == 'RUNNING'">
                                            <img src="@/assets/image/loading.png" alt="">
                                        </div>
                                        <div :class="aiImgIndex == i ? 'create_succeeses create_succeeses1' : 'create_succeeses'"
                                            v-if="item.status == 'SUCCEEDED'">
                                            <img :src="item.resultUrl" alt="">
                                        </div>
                                        <div v-if="item.status == 'FAILED'">
                                            失败
                                        </div>
                                        <div v-if="delShow" class="create_cover27_1" @click.stop="deleteImage(i)">
                                            <img src="@/assets/image/icon_del1.png" alt="">
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="create_cover28">
                                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
                                    :page-size="5" :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="create_cover29">
                    <div class="create_cover29_1" v-if="imgList.length == 0">
                        <img src="@/assets/image/no_img.png" alt="">
                        暂无
                    </div>
                    <img v-if="imgList.length && imgList[aiImgIndex]" :src="imgList[aiImgIndex].resultUrl" alt="">
                    <div class="create_cover30">效果预览</div>
                    <div class="create_cover9 cursor_1" @click="confirm">确认</div>
                </div>
            </div>
            <!-- 本地上传 -->
            <div v-if="coverI == 1" class="create_cover3">
                <div class="image-preview">
                    <input class="image-preview1" type="file" @change="previewImage" />
                    <div v-if="!imageUrl" class="image-preview2">
                        <img src="@/assets/image/upload_icon.png" alt="">
                        点击或拖拽文件到此处上传
                    </div>
                    <img class="image-preview3" v-else :src="imageUrl" @change="previewImage" />
                </div>
                <div class="create_cover6">
                    <div class="create_cover7">封面内容</div>
                    <div class="create_cover8">清晰的作品名称和作者笔名符合作品风格的内容元素</div>
                    <div class="create_cover7">封面格式</div>
                    <div class="create_cover8">建议尺寸600*800像素 jpg/png/jpeg格式，文件大小不超过5MB</div>
                    <div class="create_cover7">封面画风</div>
                    <div class="create_cover8">封面设计美观，有艺术性，与作品风格搭配可参考作品排行榜</div>
                    <div class="create_cover9" @click="uploadImg">确认</div>
                </div>
            </div>
            <!-- 模板选择 -->
            <div v-if="coverI == 2">
                <div class="create_cover3">
                    <div :class="coverImg == i ? 'create_cover4 create_cover4_1' : 'create_cover4'"
                        v-for="(item, i) in mbImgList" :key="i" @click="cCoverImg(i)">
                        <img class="create_cover4_2" :src="item.img" alt="">
                        <img v-if="coverImg == i" class="create_cover4_3" src="@/assets/image/icon_create7.png" alt="">
                    </div>

                </div>
                <div class="create_cover5" @click="confirm">确认</div>
            </div>
        </div>
    </el-dialog>

</template>

<script>
import api from '@/api/api'
import lNApi from '@/api/longNovel'
import data from '@/assets/data'
import FormData from 'form-data'
import axios from 'axios'
import { EventBus } from '@/utils/eventBus';
export default {
    data() {
        return {
            coverShow: false, //封面显示
            coverList: ['AI生成封面', '本地上传', '模板封板'],
            coverQuality: ['普通', '臻品'],//封面品质
            qualityIndex: 0,//封面品质下标 0普通 1臻品
            aiImgIndex: 0,//Ai生成封面下标
            describeText: '',//封面描述
            iconSelect: data.iconSelect,
            imgList: [],//全部ai生成封面
            mbImgList: [], //模板封面
            coverI: 0, //上传方式下标 本地上传 本地上传
            coverImg: 0, //选中图片下标
            imageUrl: '',
            total: null, //AI生成总条数
            PageNum: 0, //ai封面封面分页
            novelInfoId: null, //小说id,
            streamStatus: false, //流式请求
            streamLast: false, //流式最后一条
            streamIndex: 0, //流式请求下标
            debounceTimer: null, //防抖定时器
            typingTimer: null, // 打字效果定时器
            coverceTimer: null, //AI封面查询定时器
            url: process.env.VUE_APP_BASE_API + "/file/upload", //上传地址
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': localStorage.getItem('token_key')
            }, //请求头
            formData: new FormData(), //FormData参数
            delShow: false, //管理删除
            userInfo: {}, //用户信息

        }
    },
    watch: {
        coverShow(newVal) {
            if (!newVal && this.coverceTimer) {
                clearInterval(this.coverceTimer);
                this.coverceTimer = null;
            }
        }
    },
    beforeDestroy() {
        console.log('销毁弹窗里的定时器')
        this.close()
    },
    methods: {
        clearTimes() {
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer);
            this.streamLast = false
            this.streamStatus = false
            this.streamIndex = 0
        },
        // 打开
        open(nolId) {
            this.coverShow = true
            this.novelInfoId = nolId
            this.describeText = ''
            this.getAiCover(1)
            this.getCover(1)
            this.getUserinfo()
        },
        //关闭
        close() {
            // console.log('关闭');
            this.clearTimes();
            this.coverShow = false
        },
        // 获取模板封面 
        getCover() {
            api.getCover().then((res) => {
                if (res.code == 200) {
                    this.mbImgList = res.data
                }
            })
        },
        //获取Ai生成封面
        getAiCover(PageNum) {
            api.getAiCover(PageNum, 5).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.total = res.total
                    this.imgList = res.rows
                    if (this.PageNum == 1) {
                        if (this.imgList.length > 0 && ['SUCCEEDED', 'FAILED'].includes(this.imgList[0].status)) {
                            // 状态为 SUCCEEDED 或 FAILED 时清除定时器
                            if (this.coverceTimer) {
                                clearInterval(this.coverceTimer);
                                this.coverceTimer = null;
                                this.getUserinfo()
                            }
                        } else {
                            // 每 10 秒查询一次
                            if (!this.coverceTimer) {
                                this.coverceTimer = setInterval(() => {
                                    this.getAiCover(1);
                                    this.PageNum = 1;
                                }, 10000);
                            }
                        }
                    }

                }
            })
        },
        getUserinfo() {
            api.getUserinfo().then((res) => {
                this.userInfo = res.data
            })
        },
        getQualityText(index) {
            if (index === 0) {
                return this.userInfo.vipType === 'common'
                    ? `${this.coverQuality[index]}(${this.userInfo.imgFrequency}次)`
                    : `${this.coverQuality[index]}(无限次)`;
            }
            return `${this.coverQuality[index]}(${this.userInfo.vipImgFrequency}次)`;
        },
        handleCurrentChange(val) {
            // this.PageNum = val
            this.getAiCover(val)
            this.aiImgIndex = 0
        },
        //切换上传方式
        cCover(i) {
            this.coverI = i
        },
        // 图片切换
        cCoverImg(i) {
            this.coverImg = i
        },
        previewImage(event) {
            let file = event.target.files[0];
            this.formData.append('file', event.target.files[0])
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageUrl = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        // 确认
        confirm() {
            if (this.coverI == 0) {
                this.$emit('changeCover', this.imgList[this.aiImgIndex].resultUrl)
            } else if (this.coverI == 2) {
                this.$emit('changeCover', this.mbImgList[this.coverImg].img)
            }
            this.coverShow = false
        },
        //本地上传
        uploadImg() {
            if (!this.imageUrl) {
                this.$message({
                    type: 'warning',
                    message: '请上传图片！'
                });
                return
            }
            this.imageUrl = ''
            this.coverShow = false
        },
        //Ai生成封面品质选择
        selectQuality(i) {
            this.qualityIndex = i
        },
        //ai帮写封面描述
        getRequirement() {
            this.describeText = ''
            this.AIWrite({
                length: '长',
                haveId: true,
                type: 'xsfmms',
                params: { novelId: this.novelInfoId },
                success:(res)=>  {
                    this.streamIndex = 0
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // lNApi.longNovelHelpWriteId('xsfmms', { novelId: this.novelInfoId }).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     }else{
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamLast = true
                                }

                                if (this.streamLast) {
                                    this.streamStatus = false
                                    this.streamLast = false;
                                    this.clearTimes();
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！')
                                } else {
                                    this.getStreamContent(id);
                                }

                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimes()
                    }
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.describeText += text[index]
                    index++;
                    this.$nextTick(() => {
                        const textarea = this.$refs['nove_fm'].$el.querySelector('textarea');
                        if (textarea) {
                            // 滚动到底部
                            textarea.scrollTop = textarea.scrollHeight;
                        }
                    });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        //Ai生成封面
        createCover() {
            if (this.describeText == '') {
                this.$message.warning('请输入封面的描述')
                return
            }
            let item = {
                id: this.novelInfoId,
                writerType: 'xs',
                requirement: this.describeText,
                type: this.qualityIndex == 0 ? 'pt' : 'hy'
            }
            api.createCover(item).then((res) => {
                if (res.code == 200) {
                    this.getAiCover(1)
                    this.PageNum = 1
                }
            })
        },
        //选择Ai生成封面
        selectAiImg(i) {
            this.aiImgIndex = i
        },
        //本地上传
        uploadImg() {
            if (!this.imageUrl) {
                this.$message({
                    type: 'warning',
                    message: '请上传图片！'
                });
                return
            }
            this.imageUrl = ''

            axios.post(this.url, this.formData, {
                headers: this.headers
            })
                .then(response => {
                    let data = response.data
                    if (data.code == 200) {
                        this.$emit('changeCover', data.data.url)
                    } else {
                        this.$message({
                            message: data.msg,
                            type: "warning",
                        });
                    }
                })

            this.coverShow = false
        },
        // 删除图片
        deleteImage(i) {
            // EventBus.$emit('openPrompt', 0)
            // this.$refs.delPopup.openPrompt(0)
            this.$emit('opne')
            this.delIndex = i
        },
        //确认删除
        delConfirm() {
            api.delCover(this.imgList[this.delIndex].id).then((res) => {
                if (res.code == 200) {
                    this.imgList.splice(this.delIndex, 1);
                    if (this.imgIndex >= this.imgList.length) {
                        this.imgIndex = this.imgList.length - 1;
                    }
                    this.getAiCover(this.pageNum)
                    this.$message.success(`删除成功！`)
                }
            })

        },
    }
}
</script>

<style>
.el-dialog__header {
    padding: 0;
}

.el-dialog__body {
    padding: 0;
    background-color: var(--tech-primary);
    background-color: transparent !important;
}

.el-dialog {
    background-color: transparent !important;
    box-shadow: none;
}

#create_cover {
    padding-bottom: 20px;
    background-color: #FFFFFF;
    border-radius: 12px;
}

.create_cover1 {
    width: 100%;
    height: 70px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #DDDDDD;
    position: relative;
}

.create_cover1 img {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 20px;
}

.create_cover2 {
    font-size: 18px;
    color: #666666;
    font-weight: 400;
    margin-right: 36px;
    position: relative;
}

.create_cover2_1 {
    color: #111111;
    font-weight: bold;
}

.create_cover2_2 {
    width: 56px;
    height: 4px;
    background: #FF6603;
    position: absolute;
    bottom: -23px;
    left: 50%;
    transform: translate(-50%);
}

.create_cover3 {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    height: 355px;
    background-color: #FFFFFF;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.create_cover4 {
    width: calc((100% - 75px) / 6);
    height: 160px;
    margin-right: 15px;
    margin-bottom: 15px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}

.create_cover4_1 {
    border: 2px solid #FF8802;
}

.create_cover4:nth-child(6n) {
    margin-right: 0;
}

.create_cover4_2 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
}

.create_cover4_3 {
    width: 20px;
    position: absolute;
    top: 0;
    right: 0;
}

.create_cover5 {
    width: 96px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: var(--tech-primary);
    border-radius: 12px 12px 12px 12px;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 400;
    margin-top: 10px;
    margin-left: 572px;
}

.avatar-uploader {
    width: 200px;
    height: 280px;
    border-radius: 20px;
    border: 1px dashed #666666;
}

.avatar-uploader {
    width: 198px;
    height: 278px;
    border-radius: 20px;
    overflow: hidden;

}

.image-preview {
    width: 200px;
    height: 280px;
    border-radius: 10px;
    border: 1px dashed #666666;
    overflow: hidden;
    position: relative;
}

.image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-preview1 {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
}

.image-preview2 {
    font-size: 14px;
    color: #666666;
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 168px;
    margin: 0 auto;
    text-align: center;
    margin-top: 88px;
}

.image-preview2 img {
    width: 32px;
    height: 32px;
    margin-bottom: 20px;
}

.image-preview .image-preview3 {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.upload-demo2 {
    width: 100%;
    height: 100%;
    padding: 0 16px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666666;
}

.upload-demo2 img {
    width: 32px;
    height: 32px;
    margin-bottom: 20px;
}

.create_cover6 {
    margin-left: 20px;
}

.create_cover7 {
    font-weight: bold;
    font-size: 16px;
    color: #111111;
    margin-bottom: 16px;
}

.create_cover8 {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 22px;
}

.create_cover9 {
    width: 96px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: var(--tech-primary);
    border-radius: 12px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
}

.create_cover10 {
    display: flex;
    padding: 0 15px;
}

.create_cover11 {
    flex: 1;
    padding-right: 20px;
    border-right: 1px #DDDDDD solid;
    padding-top: 20px;
}

.create_cover12 {
    width: 100%;
    display: flex;
    position: relative;
}

.create_cover13 {
    font-weight: bold;
    font-size: 17px;
    color: #111111;
    display: flex;
    align-items: center;
}

.create_cover14 {
    width: 58px;
    height: 25px;
    background: url('@/assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.create_cover14:hover {
    background: url('@/assets/image/icon_create2.png') no-repeat;
    background-size: 100% 100%;
}

.create_cover15 {
    /* width: 100%;
    height: 100px; */
    margin: 5px 0 10px 0;
    position: relative;
}

.create_cover15 .el-textarea__inner {
    width: 100%;
    background-color: transparent;
    border: none;
    resize: none;
    outline: none;
    box-shadow: none;
    background-color: #FAFAFA;
    height: 100px;
}

.create_cover16 {
    display: flex;
    margin-bottom: 10px;
}

.create_cover17 {
    flex: 1;
    padding-left: 20px;
}

.create_cover18 {
    display: flex;
}

.create_cover19 {
    font-size: 16px;
    color: #111111;
    margin-right: 20px;
    display: flex;
    align-items: center;
}

.create_cover19 img {
    width: 19px;
    height: 19px;
    margin-right: 8px;
}

.create_cover20 {
    font-size: 13px;
    color: #888888;
    margin-top: 10px;
}

.create_cover21 {
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
}

.create_cover23 {
    display: flex;
    justify-content: space-between;
}

.create_cover24 {
    font-size: 16px;
    color: #444444;
    display: flex;
    align-items: center;
}

.create_cover24 img {
    width: 17px;
    height: 17px;
    margin-right: 3px;
}

.create_cover24_1 {
    display: flex;
    align-items: center;
}

.create_cover25 {
    width: 100%;
}

.create_cover26 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-bottom: 15px;
}

.create_cover26_1 {
    width: 100%;
    display: flex;
}

.create_cover26 {
    display: flex;
}

.create_cover26_2 {
    width: calc((100% - 40px) / 5);
    height: 119px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F5F5F5;
    border-radius: 5px;
}

.create_cover27 {
    width: calc((100% - 40px) / 5);
    height: 119px;
    background-color: #ECECEC;
    border-radius: 8px;
    margin-right: 10px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
}

.create_cover27_1 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(17, 17, 17, 0.4);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.create_cover26 .create_cover27_1 img {
    width: 29px;
    height: 29px;
}

.create_succeeses {
    width: 100%;
    height: 100%;
}

.create_succeeses img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.create_succeeses1 {
    border: 2px solid #FF6603;
}

.create_cover27 img {
    width: 100%;
    height: 100%;
}

.create_cover27:nth-child(5n) {
    margin-right: 0;
}

.create_cover28 {
    display: flex;
    justify-content: end;
}

.create_cover29 {
    display: flex;
    flex-flow: column;
    padding: 0 5px 0 20px;
    align-items: center;
    justify-content: center;
}

.create_cover29_1 {
    width: 187.5px;
    height: 250px;
    margin-top: 40px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    background-color: #F5F5F5;
}

.create_cover29 .create_cover29_1 img {
    width: 33px;
    height: 33px;
    margin-top: 5px;
}

.create_cover29 img {
    width: 187.5px;
    height: 250px;
    margin-top: 40px;
}

.create_cover30 {
    font-size: 17px;
    color: #111111;
    margin-top: 10px;
    margin-bottom: 20px;
}

.create_loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.create_loading img {
    width: 38px;
    height: 38px;
    animation: rotate 1s linear infinite;
}

.loading_text_1 {
    margin-left: 20px;
    width: 19px;
    height: 19px;
}

.loading_text_1 img {
    width: 100%;
    height: 100%;
    animation: rotate 1s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>